<div class="">
  <div class="bg-[#f7f5f0]">

    <div class="bg-[#f7f5f0] max-w-7xl mx-auto  pt-[40px] md:pt-[68px] px-4 md:px-[36px]">
      <div class="grid grid-cols-1 md:grid-cols-[1.08fr_0.92fr] gap-8 md:gap-[56px] items-start">
        <div style="padding-top:8px">
          <div class="home-hero__badge">B2B
            Wholesale Marketplace</div>
          <div class="home-hero__title">
            Source with confidence from verified European suppliers.</div>
          <div class="home-hero__subtitle">100,000+ products,
            real-time wholesale pricing and low minimums — with smart EAN matching that connects you to verified,
            trackable suppliers in seconds.</div>


          <div class="ean-widget hidden md:block">
            <div style="display:flex;gap:3px;padding:2px 2px 9px">
              <div class="ean-widget__tab--active">
                Search EANs</div>
              <div (click)="openCsvModal()" class="ean-widget__tab">
                Upload EAN List</div>
            </div>
            <div style="display:flex;gap:8px">
              <input #eanInput type="text" (keyup.enter)="onSearchEans(eanInput.value)"
                placeholder="4005900123456, 4005900654321, …" class="ean-widget__input" />
              <div (click)="onSearchEans(eanInput.value)" class="ean-widget__button">Get offers →</div>
            </div>
          </div>


          <div [routerLink]="['/category/products']"
            class="md:hidden flex items-center justify-center h-[46px] bg-[#0d182d] text-white rounded-lg text-[14.5px] font-semibold mt-[18px] cursor-pointer">
            Explore the catalog
          </div>
        </div>


        <div class="live-offers">
          <div class="live-offers__header">
            <div style="font-size:13.5px;font-weight:600;color:#0d182d">Live offers · Health &amp; Beauty</div>
            <div class="live-offers__update-time"><span class="live-offers__status-dot"></span>{{ (lastUpdatedText$ | async) || 'Updated just now' }}</div>
          </div>
          <ng-container *ngIf="liveOffers$ | async as offers; else loadingOffers">
          <div class="live-offers__table-header">
            <div style="width:38px;flex:none"></div>
            <div style="flex:1">Product</div>
            <!-- <div>Offers</div> -->
              <div class="live-offers__col-retail">Retail</div>
              <div class="live-offers__col-diff">Diff</div>
            <div class="live-offers__col-price">Best Price</div>
          </div>

            <ng-container *ngFor="let r of offers">
              <div class="live-offers__row">
                <div class="live-offers__image-placeholder">
                  <img *ngIf="r.image" [src]="r.image + '?preset=thumb'"
                    style="width: 100%; height: 100%; object-fit: contain; border-radius: 4px;" />
                  <img *ngIf="!r.image" src="assets/icons/venduro-icon-light-grey.svg"
                    style="width: 100%; height: 100%; object-fit: contain; border-radius: 4px; opacity: 0.2;" alt="" />
                </div>
                <div style="flex:1;min-width:0">
                  <div class="live-offers__product-name">
                    {{ r.name }}</div>
                  <div class="live-offers__product-ean">
                    EAN {{ r.ean }}</div>
                </div>
                <!-- <div [class.blur-text]="!(isLoggedIn$ | async) && !r.showOnLandingPage"
                  class="live-offers__offer-count">{{ r.offers }}</div> -->
                  <div [class.blur-text]="!(isLoggedIn$ | async) && !r.showOnLandingPage"
                    class="live-offers__retail">{{ r.retail }}</div>
                  <div [class.blur-text]="!(isLoggedIn$ | async) && !r.showOnLandingPage"
                    class="live-offers__diff">{{ r.diff }}</div>
                <div [class.blur-text]="!(isLoggedIn$ | async) && !r.showOnLandingPage" class="live-offers__price">
                  {{ r.price }}</div>
              </div>
            </ng-container>
          </ng-container>

          <ng-template #loadingOffers>
            <div *ngFor="let i of [1, 2, 3, 4]" class="live-offers__row animate-pulse">
              <div class="live-offers__image-placeholder" style="background: #e5e7eb"></div>
              <div style="flex:1;min-width:0;display:flex;flex-direction:column;gap:6px">
                <div style="height: 14px; background: #e5e7eb; border-radius: 4px; width: 75%"></div>
                <div style="height: 10px; background: #e5e7eb; border-radius: 4px; width: 50%"></div>
              </div>
              <div style="height: 14px; background: #e5e7eb; border-radius: 4px; width: 45px"></div>
              <div style="height: 14px; background: #e5e7eb; border-radius: 4px; width: 52px"></div>
            </div>
          </ng-template>

          <div class="live-offers__footer">
            <div style="font-size:12px;color:#8a93a3">12 suppliers bidding on this list · all VAT-verified</div>
            <div [routerLink]="['/category/products']" class="live-offers__footer-link">Open catalog →</div>
          </div>
        </div>
      </div>


      <div class="hidden md:block" style="padding:26px 0 30px">
      </div>
    </div>
  </div>


  <div class="bg-white border-b border-[#eceef2]">
    <div class="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4">
      <ng-container *ngFor="let s of stats">
        <div class="p-6 md:p-[34px_32px] border-b md:border-b-0 md:border-r border-[#eceef2]">
          <div class="stats-band__number">
            {{ s.n }}</div>
          <div class="stats-band__label">{{ s.l }}</div>
        </div>
      </ng-container>
    </div>
  </div>


  <div class="bg-white border-t border-b border-[#eceef2]">
  <div class="max-w-7xl mx-auto py-[40px] md:py-[78px] px-4 md:px-[36px]">
    <div style="max-width:620px;margin:0 auto 42px;text-align:center">
      <div class="comparison-section__badge">The
        difference</div>
      <div class="comparison-section__title">
        Sourcing the old way, vs. sourcing with Venduro.</div>
    </div>

    <div class="hidden md:grid md:grid-cols-2 gap-6 max-w-[1000px] mx-auto">
      <div class="comparison-card">
        <div style="padding:22px 26px;background:#f6e9e6">
          <div class="comparison-card__heading comparison-card__heading--bad">Sourcing without Venduro</div>
        </div>
        <div class="comparison-card__body">
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#b5493f" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M9.5 9.5l5 5M14.5 9.5l-5 5"></path>
              </svg></span>Emailing suppliers one by one to ask for a price</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#b5493f" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M9.5 9.5l5 5M14.5 9.5l-5 5"></path>
              </svg></span>No visibility into pricing until you ask</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#b5493f" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M9.5 9.5l5 5M14.5 9.5l-5 5"></path>
              </svg></span>Unclear who’s verified and who isn’t</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#b5493f" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M9.5 9.5l5 5M14.5 9.5l-5 5"></path>
              </svg></span>Comparing offers across spreadsheets and inboxes</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#b5493f" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M9.5 9.5l5 5M14.5 9.5l-5 5"></path>
              </svg></span>No shared view of order or delivery status</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#b5493f" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M9.5 9.5l5 5M14.5 9.5l-5 5"></path>
              </svg></span>Big minimum order values, often €10,000+</div>
        </div>
      </div>
      <div class="comparison-card">
        <div style="padding:22px 26px;background:#0d182d">
          <div class="comparison-card__heading comparison-card__heading--good">Sourcing with Venduro</div>
        </div>
        <div class="comparison-card__body">
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#2f8557" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M8.5 12.5l2.3 2.3 4.5-5"></path>
              </svg></span>AI-powered sourcing matches offers to your catalog automatically</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#2f8557" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M8.5 12.5l2.3 2.3 4.5-5"></path>
              </svg></span>Real-time pricing across every offer, upfront</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#2f8557" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M8.5 12.5l2.3 2.3 4.5-5"></path>
              </svg></span>Every supplier VAT/KYC-verified before listing</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#2f8557" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M8.5 12.5l2.3 2.3 4.5-5"></path>
              </svg></span>Compare verified offers side by side</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#2f8557" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M8.5 12.5l2.3 2.3 4.5-5"></path>
              </svg></span>One shared, trackable order status from quote to delivery</div>
          <div class="comparison-card__item"><span style="flex:none;margin-top:1px"><svg width="15" height="15"
                viewBox="0 0 24 24" fill="none" stroke="#2f8557" stroke-width="2.2" stroke-linecap="round"
                stroke-linejoin="round">
                <circle cx="12" cy="12" r="9"></circle>
                <path d="M8.5 12.5l2.3 2.3 4.5-5"></path>
              </svg></span>Low minimum order values, from as little as €300</div>
        </div>
      </div>
    </div>


    <div class="md:hidden flex flex-col gap-3.5 mx-auto max-w-md">
      <div class="comparison-card--mobile">
        <div class="comparison-card__title--bad">Without Venduro</div>
        <div style="font-size:13px;line-height:1.5;color:#3c4454">Emailing suppliers one by one, no visibility into
          pricing, unclear who's verified.</div>
      </div>
      <div style="background:#0d182d;border-radius:12px;padding:16px">
        <div class="comparison-card__title--good">With Venduro</div>
        <div style="font-size:13px;line-height:1.5;color:#c3cad6">Every offer, price and verification status in one live
          view.</div>
      </div>
    </div>
  </div>
  </div>


  <div id="why-venduro" class="bg-white">
    <div class="max-w-7xl mx-auto py-[40px] md:py-[78px] px-4 md:px-[36px]">
    <div style="max-width:620px">
      <div class="comparison-section__badge">Why
        buyers trust Venduro</div>
      <div class="trust-section__title">
        Built to make wholesale sourcing safer, verified and trackable.</div>
    </div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-0 mt-[42px] border-t border-[#eceef2]">
      <ng-container *ngFor="let t of trustPillars">
        <div class="p-6 md:p-[28px_26px_28px_0] md:pl-[26px] border-b md:border-b-0 md:border-r border-[#eceef2]">
          <div class="feature-card__icon">
            <div style="font-size:19px">{{ t.icon }}</div>
          </div>
          <div class="feature-card__title">{{ t.title }}</div>
          <div class="feature-card__desc">{{ t.body }}</div>
        </div>
      </ng-container>
    </div>
    </div>
  </div>


  <div class="bg-white border-t border-[#eceef2]">
  <div class="max-w-7xl mx-auto py-[40px] md:py-[78px] px-4 md:px-[36px]">
    <div class="how-it-works__title">How it works</div>
    <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5 mt-[38px]">
      <ng-container *ngFor="let st of steps">
        <div class="step-card">
          <div style="display:flex;align-items:center;gap:12px">
            <div class="step-card__number">
              {{ st.n }}</div>
            <div style="font-size:16.5px;font-weight:700;color:#0d182d">{{ st.title }}</div>
          </div>
          <div class="step-card__desc">{{ st.body }}</div>
        </div>
      </ng-container>
    </div>
  </div>
  </div>


  <div class="bg-white">
    <div class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-[1.15fr_0.85fr]">
      <div class="p-[40px_20px] md:p-[70px_44px_70px_36px] border-b md:border-b-0 md:border-r border-[#eceef2]">
        <div class="testimonial__quote">“Venduro made supplier checks, pricing
          and order tracking easier — we could compare offers without relying on unknown invoices alone.”</div>
        <div class="testimonial__author-box">
          <div class="testimonial__avatar">
          </div>
          <div>
            <div style="font-size:14px;font-weight:700;color:#0d182d">Rasa Petrauskienė</div>
            <div style="font-size:12.5px;color:#5b6472;margin-top:2px">Head of Procurement · Grožio Namai (LT)</div>
          </div>
        </div>
      </div>
      <div style="padding:56px 36px">
        <div class="testimonial__author-title">Safeguards
          on every order</div>
        <div class="certifications__list">
          <ng-container *ngFor="let c of certs">
            <div class="certifications__item">
              <span class="certifications__icon"><svg width="15" height="15" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M5 12.5l4 4 10-10"></path>
                </svg></span>
              {{ c }}
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>


  <div class="bg-white border-t border-b border-[#eceef2]">
  <div class="max-w-7xl mx-auto py-[40px] md:py-[64px] px-4 md:px-[36px]">
    <div style="max-width:620px">
      <div class="comparison-section__badge">
        Integrations</div>
      <div class="integrations__title">
        Start today, connect deeper when you're ready.</div>
      <div class="integrations__desc">Import or export your orders as a CSV
        or XML, call our REST API directly, or connect your ERP — whatever fits how your team already works.</div>
    </div>
    <div class="integrations__logos">
      <div class="integrations__logo">
        CSV import/export</div>
      <div class="integrations__logo">
        XML import/export</div>
      <div class="integrations__logo">
        REST API</div>
      <div class="integrations__logo">
        ERP integrations <span style="font-weight:500;color:#8a93a3;margin-left:6px">on request</span></div>
    </div>
  </div>
  </div>


  <div id="for-suppliers" class="bg-white">
    <div class="max-w-7xl mx-auto px-4 md:px-[36px] py-[40px] md:py-[64px]">
      <div class="cta-band">
        <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 md:gap-[32px]">
          <div style="max-width:560px">
            <div class="cta-band__badge">For
              suppliers</div>
            <div class="cta-band__title">Reach
              verified buyers across Europe.</div>
            <div class="cta-band__desc">List once, align payment release
              with agreed terms, and skip the sales overhead — we handle KYC, invoicing and order support.</div>
          </div>
          <div (click)="onStartSelling()" class="cta-band__button">
            Become a supplier →</div>
        </div>
        <div
          class="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-[28px] mt-[32px] pt-[24px] border-t border-[#24344f]">
          <div style="font-size:13px;color:#8a97b0"><span
              style="color:#ffffff;font-weight:700;font-variant-numeric:tabular-nums">1,000+</span> active buyers</div>
          <div style="font-size:13px;color:#8a97b0"><span
              style="color:#ffffff;font-weight:700;font-variant-numeric:tabular-nums">14</span> countries reached</div>
          <div style="font-size:13px;color:#8a97b0"><span
              style="color:#ffffff;font-weight:700;font-variant-numeric:tabular-nums">100+</span> suppliers already
            listed
          </div>
        </div>
      </div>
    </div>
  </div>


  <div id="faq" class="bg-white">
    <div class="max-w-7xl mx-auto pt-5 px-4 md:px-[36px] pb-[40px] md:pb-[78px]">
      <div class="how-it-works__title">Frequently asked questions</div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-y-0 gap-x-[44px] mt-[26px]">
        <div>
          <div *ngFor="let q of faqsLeftColumn; let i = index" (click)="toggleFaq(i, 'left')"
            style="border-bottom:1px solid #eceef2;cursor:pointer">
            <div class="faq-item__header">
              <div style="font-size:15px;font-weight:500;color:#0d182d">{{ q.question }}</div>
              <div style="font-size:18px;color:#8a93a3;flex:none">{{ q.isOpen ? '-' : '+' }}</div>
            </div>
            <div *ngIf="q.isOpen" class="home-section__custom-1">
              {{ q.answer }}
            </div>
          </div>
        </div>
        <div>
          <div *ngFor="let q of faqsRightColumn; let i = index" (click)="toggleFaq(i, 'right')"
            style="border-bottom:1px solid #eceef2;cursor:pointer">
            <div class="faq-item__header">
              <div style="font-size:15px;font-weight:500;color:#0d182d">{{ q.question }}</div>
              <div style="font-size:18px;color:#8a93a3;flex:none">{{ q.isOpen ? '-' : '+' }}</div>
            </div>
            <div *ngIf="q.isOpen" class="home-section__custom-2">
              {{ q.answer }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<a class="whatsapp-float" [href]="whatsappUrl" target="_blank" rel="noopener noreferrer"
  aria-label="Chat on WhatsApp">
  <img class="whatsapp-float__icon" src="assets/icons/whatsapp-icon.svg" alt="" />
</a>

<vsf-ean-search-modal
  [visible]="isCsvModalVisible"
  (close)="closeCsvModal()"
  (search)="onSearchEans($event)"
></vsf-ean-search-modal>